// extracted by mini-css-extract-plugin
export default {"container":"menu_container__37WHm","background":"menu_background__kityN","navigationGroups":"menu_navigationGroups__3QviI"};